import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './MyPayments.css';
import Navbar from './Navbar';
import Footer from './Footer';

const MyPayments = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    const uid = sessionStorage.getItem('uid');
    
    if (token && uid) {
      setIsAuthenticated(true);
      fetchPayments(uid, token);
    } else {
      setErrorMessage('Please log in to view your payments.');
      setTimeout(() => {
        navigate('/login-signup?redirect=/my-payments');
      }, 2000);
    }
  }, [navigate]);

  const fetchPayments = async (uid, token) => {
    try {
      const response = await axios.get(`https://api.rescons.in/user-info/${uid}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.data && response.data.payments) {
        setPayments(response.data.payments);
      } else {
        setPayments([]);
      }
    } catch (error) {
      console.error('Error fetching payments:', error);
      if (error.response?.status === 401) {
        setErrorMessage('Authentication failed. Please log in again.');
      } else {
        setErrorMessage('Failed to load payment history. Please try again later.');
      }
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadgeClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'captured':
     case 'paid':
    return 'status-badge success';

      case 'pending':
        return 'status-badge pending';
      case 'failed':
        return 'status-badge failed';
      case 'cancelled':
        return 'status-badge cancelled';
      default:
        return 'status-badge pending';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatAmount = (amount, currency = 'INR') => {
    if (!amount) return 'Pending for verification';
    
    // Use amount as-is since database stores in rupees, not paise
    const displayAmount = amount;
    
    if (currency === 'USD') {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(displayAmount);
    } else {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR'
      }).format(displayAmount);
    }
  };

  if (!isAuthenticated) {
    return (
      <>
        <Navbar />
        <div className="my-payments">
          <div className="my-payments-wrapper">
            <div className="loading-message">
              <p>{errorMessage || 'Loading...'}</p>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="my-payments">
          <div className="my-payments-wrapper">
            <div className="loading-message">
              <p>Loading your payment history...</p>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (errorMessage) {
    return (
      <>
        <Navbar />
        <div className="my-payments">
          <div className="my-payments-wrapper">
            <div className="error-message">
              {errorMessage}
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="my-payments">
        <div className="my-payments-wrapper">
          {/* Header */}
          <header className="payments-header">
            <h1>My Payments</h1>
            <p className="payments-description">
              View your payment history and transaction details for STIS-V 2025.
            </p>
          </header>

          

          {/* Payment History */}
          <div className="payment-history">
            <h2>Payment History</h2>
            
            {payments.length === 0 ? (
              <div className="no-payments">
                <div className="no-payments-icon">💳</div>
                <h3>No Payments Found</h3>
                <p>You haven't made any payments yet.</p>
                <button 
                  className="register-btn"
                  onClick={() => navigate('/registration-form')}
                >
                  Make Registration Payment
                </button>
              </div>
            ) : (
              <div className="payments-table-container">
                <table className="payments-table">
                                     <thead>
                     <tr>
                       <th>Payment ID</th>
                       <th>Order ID</th>
                       <th>Amount</th>
                       <th>Date</th>
                     </tr>
                   </thead>
                  <tbody>
                                         {payments.map((payment, index) => (
                       <tr key={index}>
                         <td className="payment-id">
                           {payment.paymentId || payment.merchantTransactionId || 'N/A'}
                         </td>
                         <td className="order-id">
                           {payment.orderId || payment.merchantOrderId || 'N/A'}
                         </td>
                         <td className="amount">
                           {formatAmount(payment.amount, payment.currency)}
                         </td>
                         <td className="date">
                           {formatDate(payment.createdAt || payment.timestamp)}
                         </td>
                       </tr>
                     ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Back Button */}
          <div className="back-section">
            <button 
              className="back-btn"
              onClick={() => navigate('/')}
            >
              ← Back to Home
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MyPayments; 